export default __webpack_public_path__ + "src/assets/feedback.a87f84590b49f41e8b3197931266d502.svg";